export const VALIDATE_REGISTRATION = 'VALIDATE_REGISTRATION';
export const APP_SEARCH = 'APP_SEARCH';
export const APP_SEARCH_VIEW = 'APP_SEARCH_VIEW';
export const DOWNLOAD_FILE_ACTION = 'DOWNLOAD_FILE_ACTION';
export const APP_STATUS_UPDATE = 'APP_STATUS_UPDATE';
export const RESET_APP_STATUS = 'RESET_APP_STATUS';
export const DOWNLOAD_RESET = 'DOWNLOAD_RESET';
export const UNAPPROVED_APPS = 'UNAPPROVED_APPS';
